import React, { useCallback, useRef, useState } from 'react';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import { useDispatch, useSelector } from 'react-redux';
import startIcom from '../../assets/images/Search.svg';
import infoIcon from '../../assets/images/InfoIcon.svg';
import starIcon from '../../assets/images/starWhiti.svg';
import filledStarIcon from '../../assets/images/Filled_Star.svg';
import ModalsWrapper from '../../components/Wrappers/ModalsWrapper';
import DashboardViewDetails from './components/DashboardViewDetails';
import { useAdminDashboardService } from '../../services/adminDashboardService';
import LineLoader from '../../components/Loaders/LineLoader';
import { CopyIconSvg, StarIconSvg } from '../../components/ui/Svgs';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';


dayjs.extend(utc);

const UserHistory = () => {
  const dispatch = useDispatch();

  const { fetchFilteredData } = useAdminDashboardService()

  const { loadingHistory, historyData, currentPage, previousPage, totalPages } = useSelector((state) => state.adminDashboard);

  const [selectedImage, setSelectedImage] = useState(null);
  const [copiedStates, setCopiedStates] = useState({});

  const starGenerator = (selected) => {
    return Array(5)
      .fill(0)
      .map((_, i) => {
        const isSelected = i < selected;
        return (
          // <img
          //   key={i}
          //   src={isSelected ? filledStarIcon : starIcon}
          //   alt={isSelected ? "Filled Star" : "Empty Star"}
          //   style={{
          //     marginRight: "10px",
          //     cursor: "pointer",
          //     width: "20px",
          //     height: "20px",
          //   }}
          // />
          <StarIconSvg fill={`${isSelected ? '#F2B500' : 'transparent'}`} strokeColor={`${isSelected ? '#F2B500' : 'white'}`} />
        );
      });
  };

  const observer = useRef();

  const lastItemRef = useCallback(
    (node) => {
      if (loadingHistory) return;
      if (currentPage === previousPage) return;
      if (currentPage === totalPages) return;
      if (observer.current) observer.current.disconnect();

      observer.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting) {
          fetchFilteredData(currentPage + 1);
        }
      });

      if (node) observer.current.observe(node);
    },
    [historyData, currentPage, dispatch]
  );

  const handleCopy = (index, text) => {
    navigator.clipboard.writeText(text)
      .then(() => {
        setCopiedStates({
          [index]: true,
        });

        setTimeout(() => {
          setCopiedStates((prevState) => ({
            ...prevState,
            [index]: false,
          }));
        }, 2000);
      })
      .catch((err) => console.error('Failed to copy text:', err));
  };


  return (
    <div >
      {previousPage === 1 && loadingHistory ? <LineLoader />
        :
        <div>
          {historyData?.map((data, index) => {
            const isLastItem = index === historyData?.length - 1;
            const isCopied = copiedStates[index] || false;

            return (
              <div ref={isLastItem ? lastItemRef : null} key={index} className="max-w-screen relative">
                <div className="w-full mx-auto border-b border-border pb-4 px-4 md:px-6 lg:px-8">
                  {/* Prompt Display Section */}
                  <div className="flex items-center justify-between py-3">
                    <div className="max-w-[75%] min-h-[40px] flex items-start gap-[16px]">
                      <img src={startIcom} className="mt-[4px] h-[16px] w-[16px]" alt="search icon" />
                      <div className="flex-grow">
                        <p className="leading-[24px] tracking-[-0.02em]">
                          {data.prompt}
                        </p>
                      </div>
                      <div
                        onClick={() => handleCopy(index, data.prompt)}
                        className="flex items-center pt-[5px] gap-[8px] cursor-pointer"
                      >
                        <CopyIconSvg fill={`${isCopied ? '#1A73E8' : '#1E242C'}`} />
                        {/* <span className={`${isCopied ? 'text-blue-primary' : ''}`}>{isCopied ? 'Copied' : 'Copy'}</span> */}
                      </div>
                    </div>
                    <div className="flex flex-col items-end px-[16px]">
                      <div>
                        <span className="small-texts text-secondary font-[400] leading-[16px]">Generated by: </span>
                        <span className='text-[14px]'>{data?.images[0]?.username || "username"}</span>
                      </div>
                      <div>
                        <span className="small-texts text-secondary font-[400] leading-[16px]">Date: </span>
                        <span className='text-[14px]'>
                          {dayjs
                            .utc(data?.images[0]?.timestamp)
                            .format("DD/MM/YYYY [at] h:mm A")}
                        </span>
                      </div>
                    </div>
                  </div>

                  {/* Image Grid Section */}
                  <div className="grid sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-4 gap-4 md:gap-6 lg:gap-8">
                    {data?.images.map((image, imgIndex) => (
                      <div
                        key={imgIndex}
                        className="relative group/image bg-gray-200 rounded-md"
                        style={{
                          aspectRatio: "1/1",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        {/* Image */}
                        <LazyLoadImage
                          className="w-full h-auto object-cover rounded-md"
                          src={image?.thumbnailImage ?
                            `${process.env.REACT_APP_AWS_BUCKET_URL_OTHER}/${image?.thumbnailImage}`
                            : `${process.env.REACT_APP_AWS_BUCKET_URL_OTHER}/${image?.images}`}
                          alt="your past creations"
                          effect="blur"
                        />
                        {/* <img
                          className="w-full h-auto object-cover rounded-md"
                          src={
                            image?.images?.includes("dump")
                              ? `${process.env.REACT_APP_AWS_BUCKET_URL_OTHER}/${image?.images}`
                              : `${process.env.REACT_APP_AWS_BUCKET_URL}/${image.modelName}/specific_need/${image.md5hash}/${image.images}`
                          }
                          alt="your past creations"
                        /> */}

                        {/* Overlay */}
                        <div
                          onClick={(e) => {
                            e.stopPropagation();
                            setSelectedImage(image);
                          }}
                          className="absolute top-0 h-full w-full hidden group-hover/image:flex bg-black/30 transition-all duration-300 ease-in-out"
                        >
                          {/* Top Right */}
                          <div className="absolute right-2 top-2 flex gap-2">
                            <button
                              onClick={(e) => {
                                e.stopPropagation();
                                setSelectedImage(image);
                              }}
                              className="h-[32px] w-[32px] flexCenter bg-white rounded-[8px]"
                            >
                              <img src={infoIcon} alt="infoIcon" />
                            </button>
                          </div>
                        </div>

                        {/* Star Rating and Font Family */}
                        <div className="w-fit absolute left-2 bottom-2 flex flex-col gap-3 p-2 bg-white/10 rounded-lg backdrop-blur-sm shadow-sm">
                          <p className="text-white font-bold text-xs sm:text-sm ">
                            {image.fontFamily}
                          </p>
                          <div className="flex gap-[8px]">{starGenerator(image.rating)}</div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            )
          })}
          {loadingHistory && currentPage > 1 && <div className='w-full h-[00px] py-[24px] flexCenter'>loading...</div>}
        </div>
      }

      {/* Modal */}
      {selectedImage && (
        <ModalsWrapper
          open={!!selectedImage}
          onClose={() => setSelectedImage(null)}
        >
          <DashboardViewDetails
            imageData={selectedImage}
            success={!!selectedImage}
            onClose={() => setSelectedImage(null)}
          />
        </ModalsWrapper>
      )}
    </div>
  );
};

export default UserHistory;